// Requires: `npm i -D @types/youtube` and `"types": ["youtube"]` in tsconfig
declare global {
	interface Window {
		YT: typeof YT;
		onYouTubeIframeAPIReady?: () => void;
	}
}

let ytReady: Promise<void> | null = null;

function hasYT(): boolean {
	return typeof window.YT?.Player !== 'undefined';
}

export function ensureYouTubeAPI(): Promise<void> {
	if (hasYT()) return Promise.resolve();
	if (ytReady) return ytReady;

	ytReady = new Promise<void>((resolve) => {
		const id = 'youtube-iframe-api';
		if (!document.getElementById(id)) {
			const s = document.createElement('script');
			s.id = id;
			s.src = 'https://www.youtube.com/iframe_api';
			s.async = true;
			document.head.appendChild(s);
		}

		// Preserve any existing handler so multiple loaders can coexist
		const prevHandler: (() => void) | undefined =
			window.onYouTubeIframeAPIReady;
		window.onYouTubeIframeAPIReady = () => {
			prevHandler?.();
			resolve();
		};

		// If API is already ready before our handler runs, resolve via a short poll
		const check = window.setInterval(() => {
			if (hasYT()) {
				window.clearInterval(check);
				resolve();
			}
		}, 50);
	});

	return ytReady;
}

/** Convenience getter (typed) once the API is ready */
export function getYT(): typeof YT | null {
	return hasYT() ? window.YT : null;
}
